<script lang="ts">
  import Icon from "@iconify/svelte";

  import { createEventDispatcher } from "svelte";
  import { fade, fly } from "svelte/transition";

  const dispatch = createEventDispatcher();

  export let type: "error" | "success" | "info" | null = "success";
  export let dismissible = true;
</script>

<div class=" bg-pbg-50 rounded-lg flex items-center w-80 text-xs mt-2 shadow-lg">
  <article class={`toast-${type} ${type}`} role="alert" in:fly out:fade>
    <div class="shrink-0">
      {#if type === "success"}
        <Icon icon="fluent:checkmark-circle-12-filled" class="w-6 h-6" />
      {:else if type === "error"}
        <Icon icon="fluent:checkmark-circle-12-filled" class="w-6 h-6" />
      {:else}
        <Icon icon="fluent:checkmark-circle-12-filled" class="w-6 h-6" />
      {/if}
    </div>

    <div class="text text-xs">
      <slot />
    </div>

    {#if dismissible}
      <button class="close" on:click={() => dispatch("dismiss")}>
        <Icon icon="fluent:dismiss-12-filled" class="w-3 h-3 opacity-90 text-black" />
      </button>
    {/if}
  </article>
</div>

<style lang="postcss">
  article {
    @apply px-4 py-3 rounded-lg flex items-center  w-full text-xs gap-3;
  }
  .error {
    @apply bg-pbg-800  text-error-500;
  }
  .success {
    @apply bg-pbg-800  text-green-500;
  }
  .info {
    @apply bg-primary-800 text-white;
  }

  .close {
    @apply text-textpbg-600;
  }
  button {
    color: white;
    background: transparent;
    border: 0 none;
    padding: 0;
    margin: 0 0 0 auto;
    line-height: 1;
    font-size: 1rem;
  }
</style>
